import { reactive } from 'vue'
import { browserLanguage, getLangTranslations, handlePlaceholder, selectedLanguage, t, te } from '@/plugins/i18n'

// Helper function to check if an object is empty
function isEmpty(obj) {
  return !obj || Object.keys(obj).length === 0
}

async function loadContent(type, language) {
  if (!type || !language) {
    console.warn('loadContent called with invalid parameters:', { type, language })
    return {}
  }
  try {
    const module = await import(`@/language/${type}/${type}.${language.toLowerCase()}.json`)
    return module.default || module
  } catch (error) {
    console.error('Error loading language content:', error)
    return {}
  }
}

export default function useI18n() {
  const contentState = reactive({})

  // METHODS
  async function getContent({ app, language = selectedLanguage.value, languageChanged }) {
    let changed = false
    let content = {}

    if (languageChanged) {
      content = await updateTranslations({ app, language })
      changed = true
    } else {
      content = getLangTranslations(language) || {}

      if (!contentState[app]) {
        contentState[app] = true
        Object.assign(content, await loadContent(app, language))
        changed = true
      }
    }

    return {
      content,
      changed,
    }
  }

  async function updateTranslations({ app, language = selectedLanguage.value }) {
    let content = getLangTranslations(language) || {}

    if (isEmpty(content) && contentState[app]) {
      Object.assign(content, await loadContent(app, language))
    }

    return content
  }

  function updateHtmlPageData({ language }) {
    // update html language attribute
    document.documentElement.setAttribute('lang', language)

    if (!te('meta')) {
      return
    }

    const meta = t('meta')

    // check, if PET-"app" is present
    if (document.querySelector('body[data-track-app=PET]')) {
      document.querySelector('title').innerText = [import.meta.env.VITE_PAGE_TITLE_PREFIX, meta.title]
        .filter(x => !!x)
        .join(' ')
      document.querySelector('meta[name=description]').content = meta.description
    }
  }

  return {
    browserLanguage,
    getContent,
    updateHtmlPageData,
    handlePlaceholder,
    selectedLanguage,
    t,
    te,
  }
}
